export default __webpack_public_path__ + "c8e96602cf0f6797316146c3722802cf.gif";